import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.footer',
        accordionEntry: '.footer__link-list-wrapper',
        linkListHeadline: '.footer__link-list-headline',
        linkList: '.footer__link-list',
        accordionEntryOpen: '.footer__link-list-wrapper--open',
        linkListItemLink: '.footer__link-list-item-link'
    },
    classNames: {
        iconOpen: 'icon-TickCirclePlus3',
        iconClose: 'icon-StateWhite15',
        accordionEntryOpenClass: 'footer__link-list-wrapper--open'
    },
};

class Footer {
    constructor($rootElement, options) {
        this._$rootElement = $rootElement;
        this._options = options;
        this._elements = null;
        this._isHidden = true;
    }

    init() {
        this._elements = this._getDomElements();
      
      
        this._accordion();

        this._$rootElement.find('.footer__lower-link--one-trust').on('click', (e) => {
            e.preventDefault();

            if(typeof OneTrust === 'object') {
                OneTrust.ToggleInfoDisplay();
            }
        });

        $('*[href="#cookie-center"]').on('click', (e) => {
            e.preventDefault();

            if(typeof OneTrust === 'object') {
                OneTrust.ToggleInfoDisplay();
            }
        });
    }

    _getDomElements() {
        return {
            $linkListHeadline: this._$rootElement.find(config.selectors.linkListHeadline),
            $accordionEntry: this._$rootElement.find(config.selectors.accordionEntry),
            $accordionEntryOpen: this._$rootElement.find(config.selectors.accordionEntryOpen),
            $linkList: this._$rootElement.find(config.selectors.linkList),
            $linkListItemLink: this._$rootElement.find(config.selectors.linkListItemLink),
        };
    }

    _accordion() {
       const firstEntry = this._elements.$accordionEntry[0];
       $(firstEntry).addClass('footer__link-list-wrapper--open')
        const icon = $(firstEntry).find('.icon');
        icon.removeClass(config.classNames.iconOpen);
        icon.addClass(config.classNames.iconClose);
        
        if (this._elements.$accordionEntryOpen) {
            this._$rootElement.find(config.selectors.accordionEntryOpen).children(config.selectors.linkList).css('height', `${this._elements.$linkList[0].scrollHeight + 15}px `);
        } 

        this._$rootElement.find(config.selectors.linkListHeadline).on('click', (e) => {
            const currentAccordionIcon = $(e.currentTarget).children('.icon');
            const closestWrapper =  $(e.currentTarget).closest(config.selectors.accordionEntry);
            console.log("closestWrapper", closestWrapper)
            if(this._isHidden && !closestWrapper.hasClass(config.classNames.accordionEntryOpenClass)) {
                closestWrapper.addClass(config.classNames.accordionEntryOpenClass);
                closestWrapper.children(config.selectors.linkList).css('height', `${closestWrapper.find(config.selectors.linkList)[0].scrollHeight + 15}px `)
                currentAccordionIcon.removeClass(config.classNames.iconOpen);
                currentAccordionIcon.addClass(config.classNames.iconClose);
                this._isHidden = false;
            } else {
                closestWrapper.removeClass(config.classNames.accordionEntryOpenClass);
                currentAccordionIcon.addClass(config.classNames.iconOpen);
                currentAccordionIcon.removeClass(config.classNames.iconClose);
                this._isHidden = true;
                closestWrapper.children(config.selectors.linkList).css('height', `0`);
            }
        })

        this._elements.$linkListItemLink.on('focusin',(e) => {

            const currentAccordionIcon = $(e.currentTarget).closest(config.selectors.accordionEntry).children(config.selectors.linkListHeadline).children('.icon');

           
            if (this._isHidden && !$(e.currentTarget).closest(config.selectors.accordionEntry).hasClass(this._elements.$accordionEntryOpen)) {
                $(e.currentTarget).closest(config.selectors.accordionEntry).addClass(this._elements.$accordionEntryOpen);
                $(e.currentTarget).closest(config.selectors.accordionEntry).children(config.selectors.linkList).css('height', `${$(e.currentTarget).closest(config.selectors.accordionEntry).find(config.selectors.linkList)[0].scrollHeight + 15}px `)
                currentAccordionIcon.removeClass(config.classNames.iconOpen);
                currentAccordionIcon.addClass(config.classNames.iconClose);
                this._isHidden = false;

            }
        })
    }
}

moduleRegistry.registerModule('Footer', Footer);
moduleRegistry.autoApplyModule('Footer', config.selectors.root);
